import ViverseButton from '@/components/ViverseButton'
import IconDiamond from '@/components/assets/icon_diamond.svg'
import { usePremiumPlanDialogContext } from '@/context/PremiumPlanDialogContext'
import { cn } from '@/lib/utils'
import { usePathname, useRouter } from 'next/navigation'
import { useState } from 'react'
import { useIsClient } from 'usehooks-ts'
export default function PremiumButton({
  label,
  communityUserId,
  className,
}: {
  label?: string
  communityUserId: string | undefined
  className?: string
}) {
  const isClient = useIsClient()
  const router = useRouter()
  const pathname = usePathname()
  const { openDialog } = usePremiumPlanDialogContext()

  const [menuOpen, setMenuOpen] = useState(false)

  const handleClick = () => {
    setMenuOpen(!menuOpen)
    if (pathname.includes(`/profile/${communityUserId}`)) {
      openDialog()
    } else {
      router.push(`/profile/${communityUserId}?premium=true`)
    }
  }

  return (
    <ViverseButton
      className={cn('group min-w-fit gap-[4px]', className)}
      onClick={handleClick}
      variant={'extra2'}
      disabled={!isClient}
    >
      <IconDiamond className="group-disabled:fill-vive-primary-60 size-[20px] shrink-0" />
      {label}
    </ViverseButton>
  )
}
